module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/36.590abce5.png";